import { ActivatedRouteSnapshot } from '@angular/router';

import { submissionSetupTokenizer } from '../store/tokens/submission-setup.token';

export const submissionSetupResolver = (route: ActivatedRouteSnapshot) => {
  const store = submissionSetupTokenizer();

  store.reset();
  store.loadReviewLocations();
  store.loadWorkspaceTypes();

  const parentId = (route.params['workspaceTypeId'] ||
    route.params['typeId'] ||
    route.parent?.params['workspaceTypeId']) as string | undefined;
  if (parentId) {
    store.loadWorkspaceSubTypes({ parent_id: parentId });
  }

  return !store.$isLoading() && !!store.$workspaceSubTypes()?.length;
};
